import {StateLabel} from "@platform/models/state-labels/state-label"
import {InvocationMethod} from "@generated"

export const InvocationMethodLabels: Map<InvocationMethod, StateLabel<InvocationMethod>> = new Map<InvocationMethod, StateLabel<InvocationMethod>>([
    [InvocationMethod.ComputeEngine, {state: InvocationMethod.ComputeEngine, label: "Compute Engine"}],
    [InvocationMethod.JobsV2, {state: InvocationMethod.JobsV2, label: "Jobs V2"}],
    [InvocationMethod.CloudTasks, {state: InvocationMethod.CloudTasks, label: "Cloud Tasks"}],
    [InvocationMethod.Http, {state: InvocationMethod.Http, label: "HTTP"}],
    [InvocationMethod.None, {state: InvocationMethod.None, label: "Pull"}],
])
